import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../_metronic/helpers'
import {User, PropertiesParticipationsQueryResponse, PropertiesParticipations} from './_models'
import {ClearStorage} from '../../../../../util/clearStorage'

const API_URL = process.env.REACT_APP_API_URL || 'api'
const USER_URL = `${API_URL}/user`

//BUSCA TOKEN NO LOCALSTORAGE
let token = localStorage.getItem('auth_storage')
if (token) token = token.replace(/['"]+/g, '')
let config = {
  headers: {
    Authorization: 'Bearer ' + token,
  },
}

//const GET_USERS_URL = `${API_URL}/users/query`

const getPropertiesParticipations = async (
  query: string,
  uuid?: string
): Promise<PropertiesParticipationsQueryResponse> => {
  //requisição banco de dados
  let logs = await axios
    .get(`${API_URL}/sgt/v1/properties/${uuid}/property_participations/`, config)

    .then(
      (response: AxiosResponse<Response<PropertiesParticipationsQueryResponse>>) =>
        response.data as any
    )
    .catch((error) => {
      if (error.response.status === 401) {
        ClearStorage()
      }
    })
  let data = await logs
  let data2 = {
    data: data.data,
    payload: {
      pagination: {
        page: data.current_page,
        links: data.links,
      },
    },
  }
  return data2 as any
}

// //GET USANDO AXIOS
// const getEnterprises = async (query: string): Promise<EnterprisesQueryResponse> => {

//   let page : number=0;
//   let inicio: number = 0;
//   let fim: number = 0;
//   let items_per_page: number = 0;
//   let link: any[]= [];
//   let search:string = '';
//   let data: any[] = [];

//   getQuery(query);

//   async function getQuery(query:string) {
//     console.log('getQuery',query)
// //tratamento de query
// if(query){
//   //seperação da query a pagina
//   let resultado = query.split("&");
//   console.log('resultado',resultado)
//   page =parseInt(resultado[0].split("=")[1]);

//    //seperação da query o intervalo
//   let items_per_page2 =(resultado[1].split("="));
//   items_per_page = parseInt(items_per_page2[1]);

//   if(resultado[2]){
//   let searchr = resultado[2].split("=");
//   search = searchr[1];
//   }

//   if(resultado[2]){
//     let searchr = resultado[2].split("=");
//     search = searchr[1];
//     }
// }

//   //inicio do intervalo
//   inicio =(page-1)*items_per_page;

//   //fim do intervalo
//   fim=page*items_per_page;

//   }

//   function mountPagination(total:number){
//     console.log('total',total)
//      //texto inicio paginação
//      link[0] = {
//       "url":page===1?"/?page=1":"/?page="+(page-1),
//       "label":page===1?"":"&laquo; Anterior",
//       "active": false,
//       "page": page-1
//   }

//     //texto fim da paginação
//   link[Math.ceil((total/items_per_page))+1] = {
//     "url": "/?page="+(page+1),
//     "label":"Próximo &raquo;",
//     "active": false,
//     "page": page+1
//   }

//   if(Math.ceil((total/items_per_page))===page){
//     link.pop();
//   }

//   //corpo da paginação
//   for (let i = 1; i <= Math.ceil((data.length/items_per_page)); i++) {
//     link[i] = {
//       "url": "/?page="+i,
//       "label": i,
//       "active": true,
//       "page": i
//     }
//   }

//   }

//   let url:string = '/v1/enterprises/data';
//   if(search){
//     url = url + '?search='+search;
//   }
//   //requisição banco de dados
//   let logs = await axios
//     .get(API_URL +'/v1/enterprises/data?'+query,config)
//     .then((response: AxiosResponse<Response<EnterprisesQueryResponse>>) =>
//     response.data.data
//     )
//     .catch(
//       (error) => {
//         console.log('error',error)
//       }
//     )

//     data = await logs as any;

//     await mountPagination(data.length);

//   //filtra resposta pelo intervalo de paginas
//   let intervalo = data.slice(inicio,fim) ;

//   let data2 = {
//     data: intervalo,
//      payload: {
//       pagination: {
//         page: page,
//         links: link,
//       }
//     }
//   }
//   return await data2 as any
// }

const createEnterprise = async (
  property: PropertiesParticipations
): Promise<PropertiesParticipations | undefined> => {
  let logs = await axios
    .post(API_URL + '/sgt/v1/properties/', property, config)
    .then(
      (response: AxiosResponse<Response<PropertiesParticipationsQueryResponse>>) => response.data
    )
    .catch()

  return logs as any
}

const updateEnterprise = async (
  enterprise: PropertiesParticipations
): Promise<PropertiesParticipations | undefined> => {
  let logs = await axios
    .put(API_URL + '/sgt/v1/properties/' + enterprise.uuid, enterprise, config)
    .then((response: AxiosResponse<Response<PropertiesParticipations>>) => response.data)
    .then((response: Response<PropertiesParticipations>) => response.data)
  return logs as any
}

const deleteEnterprise = (EnterpriseId: string): Promise<void> => {
  return axios.delete(API_URL + '/sgt/v1/properties/' + EnterpriseId, config).then(() => {})
}

const deleteSelectedUsers = (userIds: Array<ID>): Promise<void> => {
  const requests = userIds.map((id) => axios.delete(`${USER_URL}/${id}`))
  return axios.all(requests).then(() => {})
}

const getUserById = (id: ID): Promise<User | undefined> => {
  return axios
    .get(`${USER_URL}/${id}`)
    .then((response: AxiosResponse<Response<User>>) => response.data)
    .then((response: Response<User>) => response.data)
}
export {
  getPropertiesParticipations,
  deleteEnterprise,
  deleteSelectedUsers,
  getUserById,
  createEnterprise,
  updateEnterprise,
}
